var _circle, _circle2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#5c5560",
    r: 256
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#eee",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m476.984 213.983h-94.019-122.022v88.977h120.267c-10.825 28.892-31.377 53.028-57.674 68.45-19.809 11.629-42.894 18.29-67.536 18.29-57.328 0-106.229-36.086-125.223-86.778-5.487-14.595-8.477-30.413-8.477-46.923 0-15.213 2.545-29.832 7.217-43.45 18.042-52.509 67.858-90.25 126.483-90.25 25.964 0 50.198 7.402 70.7 20.218l72.863-59.652c-38.953-32.34-88.99-51.779-143.563-51.779-86.925 0-162.333 49.308-199.766 121.479-16.078 30.968-25.148 66.138-25.148 103.435 0 38.569 9.701 74.864 26.805 106.587 37.988 70.452 112.457 118.327 198.109 118.327 53.299 0 102.262-18.536 140.806-49.518 39.632-31.859 68.24-76.878 79.19-128.436 3.226-15.151 4.918-30.858 4.918-46.96 0-14.36-1.347-28.411-3.93-42.017z",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m396.794 431.384.013.013c-38.545 30.981-87.507 49.517-140.807 49.517-85.652 0-160.121-47.874-198.109-118.327l72.887-59.664c18.994 50.692 67.894 86.778 125.223 86.778 24.642 0 47.727-6.661 67.536-18.29z",
    fill: "#28b446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m476.984 213.983c2.583 13.606 3.93 27.657 3.93 42.017 0 16.102-1.693 31.809-4.918 46.96-10.949 51.557-39.558 96.577-79.19 128.436l-.013-.013-73.258-59.973c26.298-15.423 46.849-39.558 57.674-68.45h-120.267v-88.977h122.023z",
    fill: "#518ef8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m399.562 82.866-72.862 59.652c-20.502-12.816-44.735-20.218-70.7-20.218-58.626 0-108.441 37.741-126.483 90.25l-73.27-59.985h-.013c37.433-72.171 112.84-121.479 199.766-121.479 54.573 0 104.61 19.439 143.562 51.78z",
    fill: "#fc3f1d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFilled);
export default __webpack_public_path__ + "static/media/google-filled.9a5329d9.svg";
export { ForwardRef as ReactComponent };